import http from '@/lib/Http'

const path = '/user'

/**
 * 查询用户分页信息
 *
 * @param query
 * @param page
 * @return {Promise<unknown>}
 */
const fetchUserPage = (query, page) => {
    return http.get(path + "/page", {
        name: query.name, page: page.page, size: page.size
    })
}

const save = (data) => {
    return http.post(path, data)
}

/**
 * 登录
 * @param username 用户名
 * @param password 密码
 *
 * @returns {Promise | Promise<User>}
 */
const login = (username, password) =>{
    return http.formPost(path + "/login", {username, password})
}

/**
 * 读取当前用户
 * @returns {Promise | Promise<User>}
 */
const fetchCurrentUser = () => {
    return http.get(path + '/current')
}

const findUserInfo = id => {
    return http.get(path + '/info', {id})
}

/**
 * 登出操作
 * @returns {Promise}
 */
const logout = () => {
    return http.get(path + '/logout')
}

const modifyPwd = (id, pwd) => {
    return http.formPost(path + "/pwd", {id, pwd})
}

const deleteUser = (id) => {
    return http.del(path, {id})
}

export default {
    login,
    fetchCurrentUser,
    logout,
    modifyPwd,
    fetchUserPage,
    deleteUser,
    save,
    findUserInfo
}
